import * as types from './actionTypes';

export const getSuccess = data => {
  return {
    type: types.EVENT_LIST_SUCCESS,
    payLoad: {data, loading: false}
  };
};
export const getFailure = () => {
  return {
    type: types.EVENT_LIST_FAILURE,
    payLoad: {loading: false}
  };
};